import { render, staticRenderFns } from "./OrganizerItem.vue?vue&type=template&id=3f467bbe&"
import script from "./OrganizerItem.vue?vue&type=script&lang=js&"
export * from "./OrganizerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports